<template>
    <div class="row">
        <div v-if="servicio.danos" class="col-md-12">
            <strong>{{ $t('general.danyos') }}</strong>
            <p v-html="servicio.danos.replaceAll('\u0080', '€').replace(/\n/g, '<br>')"></p>
        </div>
        <div v-if="servicio.nota_importante" class="col-md-12">
            <strong>{{ $t('general.notaimportante') }}</strong>
            <p v-html="servicio.nota_importante.replaceAll('\u0080', '€').replace(/\n/g, '<br>')"></p>
        </div>
        <div v-if="servicio.limite_autonomia" class="col-md-12">
            <strong>Límite autonomía</strong>
            <p v-html="servicio.limite_autonomia"></p>
        </div>
        <div v-if="observaciones" class="col-md-12">
            <strong>Observaciones</strong>
            <p v-html="observaciones.replaceAll('\u0080', '€').replace(/\n/g, '<br>')"></p>
        </div>
        <div v-if="servicio.codigo" class="col-md-4">
            <strong>{{ $t('general.codigo') }}</strong>
            <p>{{servicio.codigo}}</p>
        </div>
        <div v-if="servicio.n_aviso" class="col-md-4">
            <strong>{{ $t('general.naviso') }}</strong>
            <p>{{servicio.n_aviso}}</p>
        </div>
        <div v-if="siniestro.anno_servicio" class="col-md-4">
            <strong>{{ $t('general.anyodelsiniestro') }}</strong>
            <p>{{siniestro.anno_servicio}}</p>
        </div>
        <div v-if="servicio.empresa_emisor_factura" class="col-md-12">
            <strong>{{ $t('general.empresafactura') }}</strong>
            <p>{{servicio.empresa_emisor_factura.nombre_empresa}}</p>
        </div>
        <div v-if="servicio.tipo_servicio" class="col-md-12">
            <strong>Tipo</strong>
            <p>{{servicio.tipo_servicio}}</p>
        </div>
        <div v-if="servicio.compania" class="col-md-12">
            <strong>{{ $t('general.compania') }}</strong>
            <p>{{servicio.compania.nombre}}</p>
        </div>
        <div v-if="servicio.correduria" class="col-md-12">
            <strong>{{ $t('general.companiacorreduria') }}</strong>
            <p>{{servicio.correduria.nombre}}</p>
        </div>
        <div v-if="servicio.contrato" class="col-md-12">
            <strong>{{ $t('general.contrato') }}</strong>
            <p>{{servicio.contrato}}</p>
        </div>
        <div v-if="servicio.compania_seguro" class="col-md-12">
            <strong>{{ $t('general.companiadeseguros') }}</strong>
            <p>{{servicio.compania_seguro.nombre}}</p>
        </div>
        <div v-if="servicio.gremio" class="col-md-6">
            <strong>{{ $t('general.gremio') }}</strong>
            <p>{{servicio.gremio}}</p>
        </div>
        <div v-if="servicio.cobertura" class="col-md-6">
            <strong>{{ $t('general.cobertura') }}</strong>
            <p>{{servicio.cobertura}}</p>
        </div>
        <div v-if="servicio.importe_franquicia" class="col-md-6">
            <strong>{{ $t('general.importefranquicia') }}</strong>
            <p>{{servicio.importe_franquicia}}</p>
        </div>
        <div v-if="servicio.compania_asignacion" class="col-md-6">
            <strong>{{ $t('general.companiaasignacion') }}</strong>
            <p>{{servicio.compania_asignacion}}</p>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';

export default {
    props: ['id', 'servicio', 'guardartoken','servicioext'],
    components: {
    },
    data() {
        return {
            siniestro: [],
            observaciones:'',
        }
    },
    methods: {
             
    async cargarservicio() {
        //get  modulos/pwgsapi/index.php/servicios/:id
        const api = new PwgsApi;
        const datos = await api.get("servicios/" + this.$props.id);
        this.siniestro = datos.datos;
        this.observaciones = datos.datos.observaciones;

    },

    },
    mounted() {
        this.cargarservicio();
        
    },
    watch: {
        id() {
            this.cargarservicio();

        },
       
    }
}
</script >


